import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import HotRank from "@/pages/home/components/HotRank";
import Collections from "@/pages/home/components/Collections";
import BriefFeed from "@/pages/home/components/BriefFeed";
import HotWords from "@/pages/home/components/HotWords";
import UpdateLog from "@/pages/home/components/UpdateLog";
import AddressCta from "@/pages/home/components/AddressCta";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <HotRank />
        <Collections />
        <BriefFeed />
        <HotWords />
        <UpdateLog />
        <AddressCta />
      </main>
      <Footer />
    </div>
  );
}